import React from 'react';

const Card = ({ 
  title, 
  subtitle, 
  description, 
  icon, 
  image, 
  link, 
  buttonText,
  className = "",
  animationDelay = 0,
  onClick 
}) => {
  return (
    <div 
      className={`card custom-card ${className}`} 
      data-aos="fade-up" 
      data-aos-delay={animationDelay}
      onClick={onClick}
    >
      {image && (
        <div className="card-img-top">
          <img src={image} alt={title} className="img-fluid" />
        </div>
      )}
      <div className="card-body">
        {icon && (
          <div className="card-icon">
            <i className={icon}></i>
          </div>
        )}
        {subtitle && <h6 className="card-subtitle">{subtitle}</h6>}
        <h5 className="card-title">{title}</h5>
        {description && <p className="card-text">{description}</p>}
        {buttonText && link && (
          <a href={link} className="btn btn-outline-primary">
            {buttonText}
          </a>
        )}
      </div>
    </div>
  );
};

export default Card;
